

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (
            item.target.classList?.contains('cart-drawer__summary') || 
            item.target.classList?.contains('drawer--cart'
          )) {
            console.log("change qty");

            if (!BSS_B2B?.nt?.initFunction) return;
            try {
              const wrapperId = 'bss-b2b-net-term-button-wrapper';
              const containerSelector = '.cart-drawer__checkout-buttons';
              const checkoutSelector = '[name="checkout"]';

              const container = document.querySelector(containerSelector);
              if (!container) return;

              if (container.querySelector(`#${wrapperId}`)) return;

              const wrapper = document.createElement('div');
              wrapper.id = wrapperId;
              wrapper.innerHTML = `
                <button type="button" id="bss-b2b-net-term-button" class="cart__nt-button btn btn--primary btn--icon-with-text w-full">
                  Finalizar compra
                </button>
              `;

              container.appendChild(wrapper);

              BSS_B2B.nt.initFunction()
              document.dispatchEvent(new Event("DOMContentLoaded"));

              // copy style từ checkout button
              if (typeof window.KC?.copyStyles === 'function') {
                const source = container.querySelector(checkoutSelector);
                const target = wrapper.querySelector('#bss-b2b-net-term-button');
                if (source && target) {
                  window.KC.copyStyles(source, target);
                }
              }
            } catch (e) {
              console.error('[BSS NT button]', e);
            }
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }

  let counter = 0;
let selector = "cart-drawer"
const interval = setInterval(() => {
    let element = document.querySelector(selector);
    if (element) {
        clearInterval(interval);

        if (!BSS_B2B?.nt?.initFunction) return;
        try {
          const wrapperId = 'bss-b2b-net-term-button-wrapper';
          const containerSelector = '.cart-drawer__checkout-buttons';
          const checkoutSelector = '[name="checkout"]';

          const container = document.querySelector(containerSelector);
          if (!container) return;

          if (container.querySelector(`#${wrapperId}`)) return;

          const wrapper = document.createElement('div');
          wrapper.id = wrapperId;
          wrapper.innerHTML = `
            <button type="button" style="display: block !important;" id="bss-b2b-net-term-button" class="cart__nt-button btn btn--primary btn--icon-with-text w-full">
              Finalizar compra
            </button>
          `;

          container.appendChild(wrapper);

          BSS_B2B.nt.initFunction()
          document.dispatchEvent(new Event("DOMContentLoaded"));

          // copy style từ checkout button
          if (typeof window.KC?.copyStyles === 'function') {
            const source = container.querySelector(checkoutSelector);
            const target = wrapper.querySelector('#bss-b2b-net-term-button');
            if (source && target) {
              window.KC.copyStyles(source, target);
            }
          }
        } catch (e) {
          console.error('[BSS NT button]', e);
        }

    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100); 

// let selector1 = "product-recommendations .price__default[bss-b2b-product-active='true']"
// const interval1 = setInterval(() => {
//     let element = document.querySelector(selector1);
//     if (element) {
//         console.log("Phần tử đã xuất hiện 111");
//         clearInterval(interval1);

//         const variantBlock = document.querySelector(
//           'product-recommendations .price__default[bss-b2b-product-active="true"]'
//         );
//         if (!variantBlock) return;

//         const variantId = variantBlock.getAttribute('bss-b2b-variant-id');
//         if (!variantId) return;

//         const store = BSS_B2B?.storage?.variantStorage?.store;
//         if (!store) return;

//         const variantData = store.get(Number(variantId)) || store.get(variantId);
//         if (!variantData?.value) return;

//         const appliedCP = variantData.value.appliedCP;

//         console.log('✅ appliedCP:', appliedCP);
//     } else {
//         counter += 100;
//         if (counter >= 10000) {
//             clearInterval(interval1);
//         }
//     }
// }, 100); 

let counter1 = 0;
let selector1 = "product-recommendations [bss-b2b-product-active]"
const interval1 = setInterval(() => {
    let element = document.querySelector(selector1);
    if (element) {
        clearInterval(interval1);
        window.dispatchEvent(new Event('scroll'));
        console.log('1111111111')
    } else {
        counter1 += 100;
        if (counter1 >= 10000) {
            clearInterval(interval1);
        }
    }
}, 100); 
